import React , {Component} from 'react'
import { Row, Col , Icon} from 'antd';
import { Link} from "react-router-dom";
import PropTypes from 'prop-types'
import MainLayout from "../../layouts/mainLayout";


class NotFound extends Component{
    constructor(props){
        super(props);

    }
    render(){
        return(
            <MainLayout>
            <div className={"indevelopmentWrapper"}>
                <div className="container">
                    <div className="indevelopment">
                        <Row className={"indevelopmentRow"}>
                            <Col xs={22} sm={22} md={18} lg={12} xl={12}>
                                <div className="InDevelopmentCard">
                                    <div className="inDevText">
                                        <div className="indevTop">
                                            <img src="clientAssets/vintage.png" alt=""/>
                                        </div>
                                        <h1>۴۰۴</h1>
                                        <p>متأسفانه صفحه مورد نظر یافت نشد !</p>
                                        <div className={"notFoundButtons"}>
                                            <div className={"homeSliderButtonInner"}>
                                                <Link to={"/"} className={"announcementActionButton"}>
                                                    <div>
                                                        <Icon type="home"/>
                                                    </div>
                                                    <p>بازگشت به خانه</p>
                                                </Link>
                                            </div>
                                            <div className={"homeSliderButtonInner"}>
                                                <button onClick={() => {
                                                    this.props.history.goBack()
                                                }} className={"announcementActionButton"}>
                                                    <div>
                                                        <Icon type="rollback"/>
                                                    </div>
                                                    <p>صفحه قبلی</p>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="indevBottom">
                                            <img src="clientAssets/vintage.png" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            </MainLayout>
        )
    }
}

NotFound.propTypes = {
    history: PropTypes.object,
};

export default NotFound
